/**
 * Example JavaScript singleton module
 */

var Accordion = (function($) {
  function initAccordion() {
    $(".faqs-block__headline").click(function() {
      var $headline = $(this);
      var $content = $headline.next(".faqs-block__text");
      var $parent = $headline.parent();
      var isExpanded = $headline.hasClass("faqs-block__headline--expanded");

      // Cerrar todos los elementos abiertos
      $(".faqs-block__headline").removeClass("faqs-block__headline--expanded");
      $(".faqs-block__text").slideUp();

      // Si el clicado ya estaba abierto, lo cerramos y terminamos
      if (isExpanded) return;

      // Expandir el seleccionado
      $headline.addClass("faqs-block__headline--expanded");
      $content.slideDown();
      $parent.css("height", "auto");
    });
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".faqs").length) {
      return;
    }

    initAccordion();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Accordion.init);
